import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustStats from "./components/TrustStats";
import Services from "./components/Services";
import Process from "./components/Process";
import FeaturedAutomations from "./components/FeaturedAutomations";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";

function App() {
  return (
    <div className="App bg-[#09090B] text-white">
      <Navbar />
      <main>
        <Hero />
        <TrustStats />
        <Services />
        <Process />
        <FeaturedAutomations />
        <WhyChooseUs />
        <Testimonials />
        <About />
        <FinalCTA />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
